<template>
  <div>
    <div>
      <el-button
        style="margin-bottom: 10px"
        type="primary"
        icon="el-icon-plus"
        @click="openAddChatBanKeywordsDialog()"
        >新增关键词</el-button
      ><span style="font-size: small; margin-left: 10px; color: red"
        >（说明：聊天时若触发这里的关键词将自动被永久禁言！）</span
      >
    </div>
    <el-table
      :data="list"
      border
      size="small"
      style="width: 371px"
      height="650px"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column
        prop="word"
        show-overflow-tooltip
        label="关键词"
        align="center"
        width="250"
      >
      </el-table-column>
      <el-table-column label="操作" align="center" width="120">
        <template slot-scope="scope">
          <span class="link-button" @click="remove(scope.row)">删除</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      list: [], //  列表里展示的数据
    };
  },

  async created() {
    await this.loadList();
  },

  methods: {
    /**
     * 查询集合
     */
    async loadList() {
      this.list = [];

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryChatBanKeywords`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];

      this.list = this.list.concat(listInResponse);
    },

    /**
     * 删除关键词
     */
    async remove(entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除关键词${entry.word}？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/delChatBanKeyword`,
            {
              id: entry.id,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }
        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id == entry.id) {
            this.list.splice(i, 1);
            break;
          }
        }
      } catch (e) {}
    },

    openAddChatBanKeywordsDialog() {
      dialogutil.open("AddChatBanKeywordsDialog", {
        closedCallback: () => {
          this.loadList();
        },
      });
    },
  },
};
</script>


<style lang="scss" scoped>
/deep/ .el-table__row td {
  padding: 3px 0;
}

/deep/ .el-table .cell {
  line-height: 18px;
}

.link-button {
  padding-left: 10px;
  color: rgb(37, 148, 240);
  cursor: pointer;
}
</style>